import React, { useEffect, useState } from "react";
import { Slide, Fade } from "@mui/material";
import {
  delayTime,
  fadedelayTime,
  slideDirection,
} from "../../../../utils/transitionEffectParams";
import ListHeading from "../../../common/RDTListHeading/ListHeading";
import CustomCards from "../../../common/CustomCards/CustomCards";
import Images from "../../../../utils/images";
import { CloudConfigurationData } from "../../../../utils/cardsData";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../../../utils/getHeightWidth";
import BreadcrumbHeading from "../../../common/RDTListHeading/BreadcrumbHeading";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";


export default function SelectPlatform() {
  const { t } = useTranslation();
  const [slideChecked, setSlideChecked] = useState(false);
  const navigate = useNavigate();
  const { height } = useWindowDimensions();
  const datatable_height = height - 115 + "px";

  useEffect(() => {
    document.title = t("cloudDiscovery.selectCloudPlatform");
    setSlideChecked(true);
  }, [t]);
  const cardData = CloudConfigurationData(t);

  return (
    <Slide timeout={delayTime} direction={slideDirection} in={slideChecked}>
      <Fade timeout={fadedelayTime} in={slideChecked}>
        <Container fluid className="main_content_container mx-auto p-3">
          <div
            className="position-relative bg-white"
            style={{ height: `${datatable_height}`, overflowY: "auto", overflowX: "hidden" }}
          >
            <div className="configure_mfa_heading">
              <div className="ms-4 ps-1 py-2 pt-1">
                <BreadcrumbHeading
                  dataTableHeadingText={[
                    t("cloudDiscovery.backToCloudConfiguration"),
                  ]}
                  dataTablePageLink={[
                    "/dashboard/discovery/cloudconfiguration",
                  ]}
                  pageNumber={1}
                />
              </div>
              <div className="p-2 d-flex flex-row justify-content-between w-100 ms-2">
                <div className="d-flex align-items-center fw-300 ff-poppins text-wrap ms-3 mb-2">
                  <ListHeading
                    dataTableHeadingText={[
                      t("cloudDiscovery.selectCloudConfigurationPlatform"),
                    ]}
                    dataTableHeadingIcon={Images.NetworkAnalyzer}
                  />
                </div>
              </div>
            </div>
            <div className="ms-4" style={{ marginTop: "1.5rem" }}>
              <CustomCards
                cardData={cardData}
                showButton
                buttonText={t("cloudDiscovery.addNew")}
                buttonOnClick={(item) => navigate(item.link)}
              />
            </div>
          </div>
        </Container>
      </Fade>
    </Slide>
  );
}


